import { merge } from 'lodash';

// Updates an entity cache in response to any action with response.entities.
const entities = (state = { syndicates: {}, memberSyndicates: {} }, action) => {
  if (action.response && action.response.entities) {
    return merge({}, state, action.response.entities);
  }

  return state;
};

export default entities;



// WEBPACK FOOTER //
// ./src/reducers/entities.js